export var json = {
    "title": "Firefighter Rescue Survey",
    "description": "Purpose: To increase firefighters success on the primary search and reduce civilian fire fatalities by collection and analysis of data.",
    "logo": "https://www.firefighterrescuesurvey.com/uploads/2/5/3/6/25366566/published/ffrs-logo-ffrs-shield-blue.png?1613498246",
    "logoWidth": "",
    "logoHeight": "296px",
    "logoPosition": "top",
    "pages": [
     {
      "name": "incident",
      "goNextPageAutomatic": "true",
      "elements": [
       {
        "type": "text",
        "name": "incidentDate",
        "title": "Incident Date:",
        "hideNumber": true,
        "isRequired": true,
        "inputType": "date"
       },
       {
        "type": "inputtime",
        "placeHolder": "hh:mm:ss",
        "name": "incidentTime",
        "isRequired": true,
        "startWithNewLine": false,
        "title": "Incident Time",
        "titleLocation": "top"
       },
       {
        "type": "googleplacesautocomplete",
        "name": "incidentAddress",
        "title": "Incident Address",
        "hideNumber": true,
        "isRequired": true,
        "placeHolder": "Incident Street Address"
       }

      ],
      "title": "Incident Details"
     },
     {
        "name": "prearrival",
        "goNextPageAutomatic": "true",
        "elements": [
         {
          "type": "inputtime",
          "placeHolder": "hh:mm:ss",
          "name": "fireDeptArrivedOnSceneTime",
          "title": "Time (actual) at which FD arrived on scene."
         },
         {
          "type": "radiogroup",
          "name": "scbaLocation",
          "title": "Excluding the driver operator, where are the SCBAs located on the rig that found the victim?",
          "hideNumber": true,
          "choices": [
           {
            "value": "seat",
            "text": "SCBAs are in the seat"
           },
           {
            "value": "cab",
            "text": "SCBAs are in the cab but not in the seat"
           },
           {
            "value": "exterior",
            "text": "SCBAs are in an exterior compartment"
           },
           {
            "value": "na",
            "text": "Not applicable"
           }
          ]
         },
         {
          "type": "radiogroup",
          "name": "victimOrEveryoneOutReport",
          "title": "Were there reports of victim or reports that everyone is out?",
          "hideNumber": true,
          "choices": [
           {
            "value": "yesVictim",
            "text": "Yes - Report of victims"
           },
           {
            "value": "yesEveryoneOut",
            "text": "Yes - Report of everyone out"
           },
           {
            "value": "no",
            "text": "No - No reports of victims"
           }
          ]
         },
         {
          "type": "radiogroup",
          "name":"insideVictimStatementSource",
          "visibleIf": "{victimOrEveryoneOutReport} = 'yesVictim'",
          "title": "Who made the statement about victims inside?",
          "choices": [
           {
            "value": "dispatch",
            "text": "Dispatch"
           },
           {
            "value": "bystander",
            "text": "Bystander"
           },
           {
            "value": "neighbor",
            "text": "Neighbor"
           },
           {
            "value": "police",
            "text": "Police"
           },
           {
            "value": "family-roommate",
            "text": "Family/Roommate"
           },
           {
            "value": "building-resident",
            "text": "Resident of Fire Building, Different Unit/Apartment"
           },
           {
            "value": "unknown",
            "text": "Unknown"
           }
          ],
          "hasOther": true,
          "otherText": "Other"
         },
         {
          "type": "radiogroup",
          "name": "insideVictimStatementLocationAccuracy",
          "visibleIf": "{victimOrEveryoneOutReport} = 'yesVictim'",
          "title": "Were reports of victim location correct?",
          "choices": [
           "Yes",
           "No",
           "N/A"
          ],
          "otherText": "Other"
         },
         {
          "type": "radiogroup",
          "name": "searchInitiatedConditions",
          "title": "When was search initiated? (Fire conditions)",
          "hideNumber": true,
          "choices": [
           {
            "value": "preKnockdown",
            "text": "Pre fire knockdown"
           },
           {
            "value": "duringKnockdown",
            "text": "Simultaneous with knockdown "
           },
           {
            "value": "postKnockdown",
            "text": "Post fire knockdown"
           }
          ]
         }
        ],
        "title": "Pre-arrival Conditions"
       },
       {
        "name": "occupancy",
        "goNextPageAutomatic": "true",
        "elements": [
         {
          "type": "radiogroup",
          "name": "Occupancy Type",
          "title": "What occupancy type was the victim located in?",
          "hideNumber": true,
          "choices": [
           {
            "value": "1-singlefam",
            "text": "Single Family Dwelling"
           },
           {
            "value": "2-multifam",
            "text": "Multi Family Dwelling"
           },
           {
            "value": "3-manufactured",
            "text": "Mobile/Manufactured Home"
           },
           {
            "value": "4-care",
            "text": "Care Home"
           },
           {
            "value": "5-multiuse",
            "text": "Multi-use Occupancy"
           },
           {
            "value": "6-comm",
            "text": "Commercial"
           },
           {
            "value": "7-outbuilding",
            "text": "Barn/Shed/Outbuilding"
           }
          ],
          "hasOther": true
         },
         {
          "type": "radiogroup",
          "name": "multifamilyDwellingType",
          "visibleIf": "{Occupancy Type} = '2-multifam'",
          "title": "What type multi-family dwelling were they in?",
          "choices": [
           {
            "value": "exterioraccess",
            "text": "Exterior access/Garden-style apartment (doorways exit to the outside)"
           },
           {
            "value": "interioraccess",
            "text": "Center hall apartment (doorways exit to the public hallway)"
           }
          ],
          "hasOther": true
         },
         {
          "type": "radiogroup",
          "name": "exteriorConditions",
          "title": "Exterior conditions on arrival of first due?",
          "hideNumber": true,
          "choices": [
           {
            "value": "0-nothing",
            "text": "Nothing Showing"
           },
           {
            "value": "1-smoke",
            "text": "Smoke Only"
           },
           {
            "value": "2-25",
            "text": "Less than 25% of structure involved"
           },
           {
            "value": "3-50",
            "text": "25 - 49% of structure involved"
           },
           {
            "value": "4-75",
            "text": "50 - 74% of structure involved"
           },
           {
            "value": "5-100",
            "text": "75 - 100% of structure involved"
           }
          ]
         },
         {
          "type": "boolean",
          "name": "structureVacant",
          "title": "Did the structure appear vacant or abandoned",
          "hideNumber": true
         },
         {
          "type": "rating",
          "name": "floorCount",
          "title": "Total number of above-grade floors? (exclude basement)",
          "hideNumber": true,
          "rateMax": 11,
          "maxRateDescription": "(or more)"
         },
         {
          "type": "checkbox",
          "name": "fireFloors",
          "title": "Floor(s) of fire (upon arrival)",
          "hideNumber": true,
          "choices": [
           {
            "value": "-1",
            "text": "Basement"
           },
           {
            "value": "1",
            "text": "1"
           },
           {
            "value": "2",
            "text": "2",
            "visibleIf": "{floorCount} > 1"
           },
           {
            "value": "3",
            "text": "3",
            "visibleIf": "{floorCount} > 2"
           },
           {
            "value": "4",
            "text": "4",
            "visibleIf": "{floorCount} > 3"
           },
           {
            "value": "5",
            "text": "5",
            "visibleIf": "{floorCount} > 4"
           },
           {
            "value": "6",
            "text": "6",
            "visibleIf": "{floorCount} > 5"
           },
           {
            "value": "7",
            "text": "7",
            "visibleIf": "{floorCount} > 6"
           },
           {
            "value": "8",
            "text": "8",
            "visibleIf": "{floorCount} > 7"
           },
           {
            "value": "9",
            "text": "9",
            "visibleIf": "{floorCount} > 8"
           },
           {
            "value": "10",
            "text": "10",
            "visibleIf": "{floorCount} > 9"
           },
           {
            "value": "11",
            "text": "11+",
            "visibleIf": "{floorCount} > 10"
           },
           {
            "value": "12",
            "text": "Attic"
           }
          ]
         },
         {
          "type": "checkbox",
          "name": "fireLocation",
          "title": "Location(s) of fire",
          "hideNumber": true,
          "choices": [
           {
            "value": "bedroom",
            "text": "Bedroom"
           },
           {
            "value": "bathroom",
            "text": "Bathroom"
           },
           {
            "value": "kitchen",
            "text": "Kitchen"
           },
           {
            "value": "familyroom",
            "text": "Family Room"
           },
           {
            "value": "garage",
            "text": "Garage"
           },
           {
            "value": "attic",
            "text": "Attic"
           },
           {
            "value": "exterior",
            "text": "Exterior"
           }
          ],
          "hasOther": true
         },
         {
          "type": "radiogroup",
          "name": "fireConditions",
          "title": "Fire conditions upon entry",
          "hideNumber": true,
          "choices": [
           {
            "value": "incipient",
            "text": "Incipient"
           },
           {
            "value": "roomcontents",
            "text": "Room and contents (single room)"
           },
           {
            "value": "multiroom",
            "text": "Multiple rooms (rooms and contents)"
           },
           {
            "value": "structure",
            "text": "Structure"
           }
          ]
         },
         {
          "type": "boolean",
          "name": "initialModeOfOperation",
          "title": "Initial mode of Operation",
          "hideNumber": true,
          "labelTrue": "Offensive",
          "labelFalse": "Defensive"
         },
         {
          "type": "inputtime",
          "placeHolder": "hh:mm:ss",
          "name": "incidentWaterOnFireTime",
          "title": "Time (actual) at which water was on the fire."
         },
         {
          "type": "radiogroup",
          "name": "workingSmokeAlarms",
          "title": "Did the structure have working smoke alarms?",
          "hideNumber": true,
          "choices": [
           {
            "value": "yes",
            "text": "Yes"
           },
           {
            "value": "no",
            "text": "No"
           },
           {
            "value": "unknown",
            "text": "Unknown"
           }
          ],
          "colCount": 1
         }
        ],
        "title": "Occupancy & Conditions"
       },
       {
        "name": "victims",
        "elements": [
         {
          "type": "text",
          "name": "victimsRemovedCount",
          "title": "How many victims were removed from the structure?",
          "isRequired": true,
          "inputType": "number",
          "min": "1",
          "max": "99",
          "step": 1
         },
         {
          "type": "paneldynamic",
          "name": "victimDetail",
          "goNextPageAutomatic": "true",
          "title": "Victim Details",
          "hideNumber": true,
          "bindings": {
           "maxPanelCount": "victimsRemovedCount"
          },          
					"templateElements": [
          {
            "type": "expression",
            "name": "victimOrdinal",
            "minWidth": "",
            "startWithNewLine": false,
            "title": "Victim",
            "titleLocation": "hidden",
            "expression": "\"Victim \" + ({panelIndex} + 1)",
            "useGrouping": false
            },
           {  
            "type": "inputtime",
            "placeHolder": "hh:mm:ss",
            "name": "victimReachTime",
            "title": "Time (actual) at which FD reached the victim"
           },
           {
            "type": "inputtime",
            "placeHolder": "hh:mm:ss",
            "name": "victimUnitArrivalTime",
            "title": "Arrival time (actual) of unit that performed the rescue"
           },
           {
            "type": "radiogroup",
            "name": "arrivalOrder",
            "title": "What was the arrival order of the crew that found victim?",
            "hideNumber": true,
            "choices": [
             {
              "value": "1",
              "text": "First in"
             },
             {
              "value": "2",
              "text": "Second in"
             },
             {
              "value": "3",
              "text": "Third in"
             },
             {
              "value": "4",
              "text": "Fourth in or later"
             }
            ]
           },
           {
            "type": "radiogroup",
            "name": "firefightersOnSceneCount",
            "title": "Number of firefighters on scene when the victim was located?",
            "hideNumber": true,
            "choices": [
             {
              "value": "1",
              "text": "1"
             },
             {
              "value": "2",
              "text": "2"
             },
             {
              "value": "3",
              "text": "3"
             },
             {
              "value": "4",
              "text": "4"
             },
             {
              "value": "7",
              "text": "5 - 7"
             },
             {
              "value": "11",
              "text": "8 - 11"
             },
             {
              "value": "15",
              "text": "12 - 15"
             },
             {
              "value": "16",
              "text": "16+"
             }
  
            ]
           },
           {
            "type": "radiogroup",
            "name": "victimFloor",
            "title": "Which floor was the victim found?",
            "choices": [
             {
              "value": "-1",
              "text": "Basement"
             },
             {
              "value": "1",
              "text": "1"
             },
             {
              "value": "2",
              "text": "2",
              "visibleIf": "{floorCount} > 1"
             },
             {
              "value": "3",
              "text": "3",
              "visibleIf": "{floorCount} > 2"
             },
             {
              "value": "4",
              "text": "4",
              "visibleIf": "{floorCount} > 3"
             },
             {
              "value": "5",
              "text": "5",
              "visibleIf": "{floorCount} > 4"
             },
             {
              "value": "6",
              "text": "6",
              "visibleIf": "{floorCount} > 5"
             },
             {
              "value": "7",
              "text": "7",
              "visibleIf": "{floorCount} > 6"
             },
             {
              "value": "8",
              "text": "8",
              "visibleIf": "{floorCount} > 7"
             },
             {
              "value": "9",
              "text": "9",
              "visibleIf": "{floorCount} > 8"
             },
             {
              "value": "10",
              "text": "10",
              "visibleIf": "{floorCount} > 9"
             },
             {
              "value": "11",
              "text": "11+",
              "visibleIf": "{floorCount} > 10"
             },
             {
              "value": "99",
              "text": "Attic"
             }
            ]
           },
           {
            "type": "radiogroup",
            "name": "victimRoom",
            "title": "Which room was the victim located?",
            "choices": [
             "Balcony / Porch / Deck",
             "Basement",
             "Bathroom",
             "Bedroom",
             "Family",
             "Foyer",
             "Garage",
             "Hallway",
             "Kitchen",
             "Laundry",
             "Stairs"
            ],
            "hasOther": true,
            "colCount": 1
           },
           {
            "type": "boolean",
            "name": "victimOtherVictimsNearby",
            "visibleIf": "{victimsRemovedCount} > 1",
            "title": "Were any other victims found in this same room/vicinity?"
           }, 
           {
            "type": "radiogroup",
            "name": "victimRoomConditions",
            "title": "Conditions at victim location?",
            "choices": [
              "Fire",
              "Fire and Smoke",
              "Smoke",
              "No fire/No smoke"
            ],
            "hasOther": false,
            "colCount": 1
           },

           {
            "type": "boolean",
            "name": "victimIsolated",
            "title": "Was the victim behind a closed door/isolated from fire?"
           },
           {
            "type": "radiogroup",
            "name": "victimLocation",
            "title": "Location of victim",
            "choices": [
             "Bathtub / Shower",
             "Closet",
             "Couch / Sofa / Chair",
             "Floor",
             "In Crib",
             "On Bed",
             "On Floor Under Window",
             {
              "value": "On floor within 6 feet of exterior door",
              "text": "On floor within 6' of exterior door"
             },
             "On Top Bunk",
             "Standing",
             "Under Bed",
             "Vehicle"
            ],
            "hasOther": true,
            "colCount": 1
           },
           {
            "type": "radiogroup",
            "name": "victimVisibility",
            "title": "Visibility at victim location",
            "hideNumber": true,
            "choices": [
             {
              "value": "high",
              "text": "High visibility (Can easily make out shapes overe 10 feet in front of your face)"
             },
             {
              "value": "moderate",
              "text": "Moderate visibility (Can make out shapes from 1 foot to 10 feet in front of your face)"
             },
             {
              "value": "low",
              "text": "Low visibility (Can make out shapes up to 1 foot in front of your face)"
             },
             {
              "value": "zero",
              "text": "Zero visibility (Lights out, searching with hands only)"
             }
            ]
           },
           {
            "type": "radiogroup",
            "name": "victimAge",
            "title": "Approximate age of victim?",
            "hideNumber": true,
            "choices": [
             {
              "value": "0",
              "text": "0 - 2 years of age"
             },
             {
              "value": "3",
              "text": "3 - 5"
             },
             {
              "value": "6",
              "text": "6 - 12"
             },
             {
              "value": "13",
              "text": "13 - 18"
             },
             {
              "value": "19",
              "text": "19 - 39"
             },
             {
              "value": "40",
              "text": "40 - 60"
             },
             {
              "value": "60",
              "text": "> 60"
             }
            ],
            "colCount": 1
           },
           {
            "type": "radiogroup",
            "name": "victimWeight",
            "title": "Approximate weight of victim",
            "hideNumber": true,
            "choices": [
             {
              "value": "0",
              "text": "< 25 pounds"
             },
             {
              "value": "25",
              "text": "25 - 50 pounds"
             },
             {
              "value": "51",
              "text": "51 - 100 pounds"
             },
             {
              "value": "101",
              "text": "101 - 200 pounds"
             },
             {
              "value": "201",
              "text": "201 - 300 pounds"
             },
             {
              "value": "301",
              "text": "> 300 pounds"
             }
            ],
            "colCount": 1
           },
           {
            "type": "radiogroup",
            "name": "victimFoundBy",
            "title": "Who found the victim",
            "hideNumber": true,
            "choices": [
             "Not applicable / Victim showing upon arrival",
             "Fire Attack",
             "Primary Search",
             "Secondary Search",
             "Police",
             "Salvage and Overhaul",
             "Ventilation"
            ],
            "hasOther": true,
            "colCount": 1
           },
           {
            "type": "boolean",
            "name": "searchCrewHoseLinePresent",
            "visibleIf": "{panel.victimFoundBy} = 'Primary Search' or {panel.victimFoundBy} = 'Secondary Search'",
            "title": "Did search crew that located the victim physically have a hose line with them during search?"
           },
           {
            "type": "radiogroup",
            "name": "searchCrewMethod",
            "visibleIf": "{panel.victimFoundBy} = 'Primary Search' or {panel.victimFoundBy} = 'Secondary Search'",
            "title": "What methods of search were used in locating the victim?",
            "choices": [
             {
              "value": "leftrighthand",
              "text": "Left/Right Hand - A left- or right-hand search with 2 or more firefighters moving in the same direction"
             },
             {
              "value": "splitsearch",
              "text": "Split Search- 2 or more firefighters searching independently."
             },
             {
              "value": "orientedsearch",
              "text": "Oriented Search - 1 crewmember stays oriented to the exit and doesn&#39;t actively participate in search."
             },
             {
              "value": "ves",
              "text": "VES - A search initiated from a window"
             },
             {
              "value": "rope",
              "text": "Rope Assisted Search/Search Line - Searching directly off of a previously placed rope or hoseline."
             }
            ]
           },
           {
            "type": "boolean",
            "name": "vesVictimFoundInitialRoomEntered",
            "visibleIf": "{panel.searchCrewMethod} = 'ves'",
            "title": "Was victim found in the initial room of entry?"
           },
           {
          "type": "radiogroup",
            "name": "victimFirefightersAssigned",
            "title": "Number of firefighters assigned to search before victim was located?",
            "choices": [
             {
              "value": "0",
              "text": "None"
             },
             "1",
             "2",
             "3",
             "4",
             "5",
             {
              "value": "6",
              "text": "6 or more"
             }
            ]
           },
           {
            "type": "radiogroup",
            "name": "victimLocationMethod",
            "title": "How was victim initially located?",
            "hideNumber": true,
            "choices": [
             "TIC (Thermal Imaging Camera)",
             "Eyes (No TIC)",
             "Hands",
             "Ears (Responded to call out)",
             "Ears (Heard victim cough, cry, move, etc.)"
            ]
           },
           {
            "type": "panel",
            "name": "victimExtraction",
            "elements": [
             {
              "type": "inputtime",
              "placeHolder": "hh:mm:ss",
              "name": "victimRemovedTime",
              "title": "Time (hh:mm) at which victim was removed from structure"
             },
             {
              "type": "radiogroup",
              "name": "victimExtractionMoveMethod",
              "title": "How was victim moved inside the structure?",
              "hideNumber": true,
              "choices": [
               "Walk or crawl under victim’s own power",
               "Drag or carry with firefighter(s) hands",
               "Drag or carry with webbing"
              ]
              ,
             "hasOther": true
             },
             {
              "type": "radiogroup",
              "name": "victimExtractionPath",
              "title": "Path of extraction?",
              "hideNumber": true,
              "choices": [
               "Window (head first)",
               "Window (feet first)",
               "Door",
               "Not removed"
              ],
              "hasOther": true
             },
             {
              "type": "radiogroup",
              "name": "victimExtractionGroundMethod",
              "visibleIf": "{panel.victimFloor} <> 1",
              "title": "How was victim brought to ground level?",
              "description": "(N/A if victim on first floor)",
              "hideNumber": true,
              "choices": [
               "Ground ladder",
               "Aerial ladder",
               "Not applicable/First floor window",
               "Interior stairs",
               "Exterior stairs"
              ],
              "hasOther": true
             },
             {
              "type": "radiogroup",
              "name": "victimExtractionInteriorStairs",
              "visibleIf": "{panel.victimFloor} <> 1",
              "title": "Was victim moved up or down interior stairs?",
              "description": "(N/A if victim on first floor)",
              "choices": [
               {
                "value": "No",
                "text": "No"
               },
               {
                "value": "Up",
                "text": "Yes - Victim was moved UP stairs"
               },
               {
                "value": "Down",
                "text": "Yes - Victim was moved DOWN stairs"
               }
              ]
             },
             {
              "type": "boolean",
              "name": "victimExtractionSIP",
              "title": "Was victim ever purposefully sheltered in placed (for over 2 minutes)?",
              "hideNumber": true
             },
             {
              "type": "radiogroup",
              "name": "victimExtractionPersonnelNeeded",
              "title": "Number of personnel that were needed for removal",
              "choices": [
               {
                "value": "1",
                "text": "1"
               },
               {
                "value": "2",
                "text": "2"
               },
               {
                "value": "3",
                "text": "3"
               },
               {
                "value": "4",
                "text": "4 - 6"
               },
               {
                "value": "7",
                "text": "> 6"
               }
              ]
             },
             {
              "type": "panel",
              "name": "victimOutcome",
              "elements": [
               {
                "type": "radiogroup",
                "name": "victimOutcomesCyanokit",
                "title": "Was a Cyanokit used on scene?",
                "hideNumber": true,
                "choices": [
                 {
                  "value": "Yes",
                  "text": "Yes"
                 },
                 {
                  "value": "No",
                  "text": "No - Cyanokit was present but not used"
                 },
                 {
                  "value": "NA",
                  "text": "No - Cyanokit was not available on scene"
                 }
                ]
               },
               {
                "type": "boolean",
                "name": "victimOutcomesCPR",
                "title": "Was CPR performed on victim?",
                "hideNumber": true
               },
               {
                "type": "boolean",
                "name": "victimOutcomesHospital",
                "title": "Was victim transported to hospital?",
                "hideNumber": true
               },
               {
                "type": "boolean",
                "name": "victimOutcomesConscious",
                "title": "Was victim conscious upon removal from structure?",
                "hideNumber": true
               },
               {
                "type": "radiogroup",
                "name": "victimOutcomesBurns",
                "title": "Victim Burns",
                "hideNumber": true,
                "choices": [
                 "None",
                 "Mild",
                 "Severe"
                ]
               },
               {
                "type": "boolean",
                "name": "victimOutcomesSmokeInhalation",
                "title": "Did victim suffer smoke inhalation?",
                "hideNumber": true
               },
               {
                "type": "boolean",
                "name": "victimOutcomesFinalOutcome",
                "title": "Victim outcome (based on most current information)",
                "hideNumber": true,
                "labelTrue": "Alive",
                "labelFalse": "Deceased"
               }
              ],
              "title": "Outcomes"
             }
            ],
            "title": "Victim Extraction"
           }
          ],
          "panelCount": 1,
          "minPanelCount": 1,
          "maxPanelCount": 1,
          "confirmDelete": true,
          "panelAddText": "Add Next Victim Details",
          "panelRemoveText": "Remove Previous Victim Details",
          "panelPrevText": "Previous Victim Details",
          "panelNextText": "Next Victim Details",
          "showRangeInProgress": true
          },
          {
          "type": "expression",
          "name": "victimDetailsProvided",
          "title": "{victimDetailCount} of {victimsRemovedCount} provided"
          }
          ],
          "title": "Victim(s)",
          "description": "Enter details for 1 or more victims, when you are done, hit [Next]."
          },
       {
        "name": "contact",
        "elements": [
         {
          "type": "text",
          "name": "contactLink",
          "title": "If you would like to attach a video/article/press release about this grab, enter the link/url here:",
          "description": "[OPTIONAL, do not fill out if not providing]",
          "hideNumber": true,
          "inputType": "url"
         },
         {
          "type": "boolean",
          "name": "contactSharePermission",
          "visibleIf": "{contactLink} notempty",
          "minWidth": "200px",
          "startWithNewLine": false,
          "title": "May we share this link online and via social media?",
          "hideNumber": true
         },
         {
          "type": "boolean",
          "name": "contactPermission",
          "title": "Can we contact you?",
          "hideNumber": true
         },
         {
          "type": "text",
          "name": "contactPhone",
          "visibleIf": "{contactPermission} = true",
          "title": "Preferred contact phone #",
          "hideNumber": true,
          "inputType": "tel"
         },
         {
          "type": "text",
          "name": "contactEmail",
          "visibleIf": "{contactPermission} = true",
          "startWithNewLine": false,
          "title": "Preferred contact email",
          "hideNumber": true,
          "inputType": "email"
         }
        ],
        "title": "Complete the Survey"
       }
      ],
    "triggers": [
        {
        "type": "copyvalue",
        "expression": "{incidentTime} notempty",
        "fromName": "incidentTime",
        "setToName": "fireDeptArrivedOnSceneTime"
        },
        {
        "type": "copyvalue",
        "expression": "{fireDeptArrivedOnSceneTime} notempty",
        "fromName": "fireDeptArrivedOnSceneTime",
        "setToName": "incidentWaterOnFireTime"
        },
        {
        "type": "copyvalue",
        "expression": "{fireDeptArrivedOnSceneTime} notempty",
        "fromName": "fireDeptArrivedOnSceneTime",
        "setToName": "searchInitiatedTime"
        },
        {
          "type": "copyvalue",
          "expression": "{fireDeptArrivedOnSceneTime} notempty",
          "fromName": "fireDeptArrivedOnSceneTime",
          "setToName": "victimDetail[0].victimUnitArrivalTime"
          },
        {
        "type": "copyvalue",
        "expression": "{fireDeptArrivedOnSceneTime} notempty",
        "fromName": "fireDeptArrivedOnSceneTime",
        "setToName": "victimDetail[0].victimReachTime"
        },
        {
        "type": "copyvalue",
        "expression": "{fireDeptArrivedOnSceneTime} notempty",
        "fromName": "fireDeptArrivedOnSceneTime",
        "setToName": "victimDetail[0].victimRemovedTime"
        },
        {
        "type": "copyvalue",
        "expression": "{victimDetail[0].victimReachTime} notempty",
        "fromName": "victimDetail[0].victimReachTime",
        "setToName": "victimDetail.victimReachTime"
        },
        {
        "type": "copyvalue",
        "expression": "{victimDetail[0].victimRemovedTime} notempty",
        "fromName": "victimDetail[0].victimRemovedTime",
        "setToName": "victimDetail.victimRemovedTime"
        }
        
    ],
      "showQuestionNumbers": "off",
      "showProgressBar": "top",
      "progressBarType": "buttons"
     }



// WEBPACK FOOTER //
// ./src/survey_json.js